import BookOpenIcon from '@atlaskit/icon-lab/core/book-open';
import * as React from 'react';

export function SvgBook() {
  return <BookOpenIcon label="" testId="ads-refreshed-icon" />;
}
